// plugins/browser-compat.client.js
export default function() {
    // 这个插件只在客户端运行
    if (process.client) {
      /**
       * 纯CSS修复方案 - 适用于旧版浏览器中Element Plus弹窗显示问题
       * 不修改任何JavaScript逻辑，仅调整CSS使弹窗可见
       */
      (function() {
        // 检测是否需要兼容
        function isOldBrowser() {
          const ua = navigator.userAgent;
          return /Chrome\/8[0-6]\./.test(ua) || // Chrome 80-86
                 /QIHU/.test(ua) ||             // 360浏览器
                 /UBrowser/.test(ua);           // UC浏览器
        }
  
        // 如果不是旧版浏览器，则不执行兼容代码
        if (!isOldBrowser()) {
          console.log('当前是现代浏览器，无需CSS兼容');
          return;
        }
  
        console.log('检测到旧版浏览器，应用纯CSS兼容性方案...');
  
        // 创建样式元素
        function addCompatStyles() {
          const style = document.createElement('style');
          style.textContent = `
            /* ============== Element Plus 弹窗样式修复 ============== */
            
            /* 消息框遮罩层修复 */
            .el-overlay.is-message-box {
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              position: fixed !important;
              top: 0 !important;
              right: 0 !important;
              bottom: 0 !important;
              left: 0 !important;
              z-index: 2000 !important;
              background-color: rgba(0, 0, 0, 0.5) !important;
              overflow: auto !important;
            }
            
            /* 消息框层修复 */
            .el-overlay-message-box {
              position: static !important;
              margin: auto !important;
              padding: 0 !important;
              max-width: 420px !important;
              transform: none !important;
            }
            
            /* 消息框本身修复 */
            .el-message-box {
              position: static !important;
              margin: 0 !important;
              top: auto !important;
              left: auto !important;
              transform: none !important;
              max-width: 420px !important;
            }
            
            /* ============== 自定义弹窗修复 ============== */
            
            /* before-exam弹窗容器修复 */
            .before-exam {
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              position: fixed !important;
              top: 0 !important;
              right: 0 !important;
              bottom: 0 !important;
              left: 0 !important;
              z-index: 2000 !important;
              background-color: rgba(0, 0, 0, 0.5) !important;
              overflow: auto !important;
            }
            
            /* before-exam弹窗内容修复 */
            .before-exam-container {
              position: static !important;
              margin: auto !important;
              transform: none !important;
              max-width: 80% !important;
            }
            
            /* ============== Element Plus对话框修复 ============== */
            
            /* 对话框容器修复 */
            .el-dialog__wrapper {
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
              position: fixed !important;
              top: 0 !important;
              right: 0 !important;
              bottom: 0 !important;
              left: 0 !important;
              z-index: 2000 !important;
              overflow: auto !important;
            }
            
            /* 对话框本身修复 */
            .el-dialog {
              position: static !important;
              margin: auto !important;
              transform: none !important;
              max-width: 80% !important;
            }
            
            /* ============== 确保弹窗可见性修复 ============== */
            
            /* 确保打开的弹窗可见 */
            .el-overlay.is-message-box[style*="display: none"] {
              display: flex !important;
            }
            
            .before-exam[style*="display: none"] {
              display: flex !important;
            }
            
            .el-dialog__wrapper[style*="display: none"] {
              display: flex !important;
            }
            
            /* 优先级提升，确保样式生效 */
            body .el-overlay.is-message-box,
            body .before-exam,
            body .el-dialog__wrapper {
              display: flex !important;
              align-items: center !important;
              justify-content: center !important;
            }
            
            body .el-overlay-message-box,
            body .before-exam-container,
            body .el-dialog {
              position: static !important;
              margin: auto !important;
              transform: none !important;
            }
          `;
          
          // 添加到head以确保优先级
          document.head.appendChild(style);
        }
  
        // 监听DOM变化，动态应用样式
        function setupMutationObserver() {
          const observer = new MutationObserver(function(mutations) {
            mutations.forEach(function(mutation) {
              if (mutation.addedNodes.length) {
                for (let i = 0; i < mutation.addedNodes.length; i++) {
                  const node = mutation.addedNodes[i];
                  
                  // 只处理元素节点
                  if (node.nodeType !== 1) continue;
                  
                  // 检查是否是弹窗相关元素
                  if (node.classList && (
                      node.classList.contains('el-overlay') ||
                      node.classList.contains('before-exam') ||
                      node.classList.contains('el-dialog__wrapper')
                  )) {
                    // 直接应用内联样式以确保显示
                    node.style.display = 'flex';
                    node.style.alignItems = 'center';
                    node.style.justifyContent = 'center';
                    
                    // 查找子元素并修复
                    if (node.classList.contains('el-overlay')) {
                      const messageBox = node.querySelector('.el-overlay-message-box');
                      if (messageBox) {
                        messageBox.style.position = 'static';
                        messageBox.style.margin = 'auto';
                        messageBox.style.transform = 'none';
                      }
                      
                      const dialogBox = node.querySelector('.el-message-box');
                      if (dialogBox) {
                        dialogBox.style.position = 'static';
                        dialogBox.style.margin = '0';
                        dialogBox.style.transform = 'none';
                      }
                    } else if (node.classList.contains('before-exam')) {
                      const container = node.querySelector('.before-exam-container');
                      if (container) {
                        container.style.position = 'static';
                        container.style.margin = 'auto';
                        container.style.transform = 'none';
                      }
                    } else if (node.classList.contains('el-dialog__wrapper')) {
                      const dialog = node.querySelector('.el-dialog');
                      if (dialog) {
                        dialog.style.position = 'static';
                        dialog.style.margin = 'auto';
                        dialog.style.transform = 'none';
                      }
                    }
                  }
                }
              }
            });
          });
          
          // 监听body变化
          observer.observe(document.body, { 
            childList: true,
            subtree: false // 只监听直接子元素，提高性能
          });
        }
  
        // 初始化修复
        function init() {
          // 应用CSS样式修复
          addCompatStyles();
          
          // 设置DOM监听器
          setupMutationObserver();
          
          console.log('纯CSS兼容性修复已应用');
        }
  
        // 等待DOM就绪后初始化
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', init);
        } else {
          init();
        }
      })();
    }
  }